<template>
  <div>
    <div class="setting-item verticallyCenter">
      <!--      <div class="options mb16">动画类型</div>-->
      <!-- <ul class="animate-types">
        <li
          v-for="(animate, index) in animateTypes"
          :class="animate.type == animateType ? 'active' : ''"
          @click="changeAnimateType(animate)"
          :key="index"
        >
          <div class="animate-icon-box">
            <span class="animate-icon" :class="animate.animateIcon"></span>
            <i v-if="animate.type == animateType" class="animate-selected"></i>
          </div>
          <p>{{ animate.name }}</p>
        </li>
      </ul> -->
      <div class="options mr16">动画类型</div>
      <div class="content">
        <el-radio-group v-model="animateType" @change="changeAnimateType(animateTypes[animateType])">
          <el-radio
            v-for="(animate, index) in animateTypes"
            :key="index"
            :label="animate.type"
            >{{ animate.name }}</el-radio
          >
        </el-radio-group>
      </div>
    </div>
    <div class="setting-item verticallyCenter" v-show="hasDirection">
      <div class="options mr16">方向</div>
      <div class="content">
        <el-radio-group v-model="animateDirection" @change="getCheckedHandle($event, options, '方向')">
          <el-radio
            v-for="(option, index) in animateDirections.list"
            :key="index"
            :label="option.title"
            :disabled="option.disabled"
            >{{ option.title }}</el-radio
          >
        </el-radio-group>
      </div>
    </div>
    <div class="setting-item" v-show="hasDirection">
      <slider-and-input :value.sync="animateDuration" title="持续" titlePosition="allInOneLine" suffix="秒" :sliderMin="animateDelay + 1" :sliderMax="200" />
    </div>
    <div class="setting-item" v-show="hasDirection">
      <slider-and-input :value.sync="animateDelay" title="停留" titlePosition="allInOneLine" suffix="秒" :sliderMax="10" />
    </div>
    <div class="setting-item verticallyCenter" v-show="hasDirection">
      <div class="options mr16">触发</div>
      <div class="content">
        <el-radio-group v-model="animateTriggerNumType" @change="getCheckedHandle($event, options, '触发方式')">
          <el-radio
            v-for="(option, index) in triggerstyles.list"
            :key="index"
            :label="option.title"
            :disabled="option.disabled"
            >{{ option.title }}</el-radio
          >
        </el-radio-group>
      </div>
    </div>
      <el-button class="setting-item" @click="restoreSettings" v-show="hasDirection">
        恢复默认
      </el-button>
  </div>
</template>

<script>
export default {
  name: "animate-set",
  props: {
    options: { type: [Object, String], default: null },
    container_id: { type: Number, default: null },
    rect_id: { type: Number, default: null }
  },
  data() {
    return {
      this1: this,
      initialSets: {
        animateType: 0,
        animateDirection: "无",
        animateDuration: 1.5,
        animateDelay: 0,
        hasDirection: false,
        animateTriggerNumType: "单次触发",
        animateClass: "",
        executionAnimateClass: ""
      },
      animateDirections: {
        type: "动画方向",
        checked: "无",
        list: [
          // {
          //   disabled: false,
          //   title: '向左'
          // }, {
          //   disabled: false,
          //   title: '向右'
          // }, {
          //   disabled: false,
          //   title: '向上'
          // }, {
          //   disabled: false,
          //   title: '向下'
          // }
        ]
      },
      triggerstyles: {
        type: "触发次数",
        checked: "单次触发",
        list: [
          {
            disabled: false,
            title: "单次触发"
          },
          {
            disabled: false,
            title: "多次触发"
          }
        ]
      },
      animateTypes: [
        {
          type: 0,
          name: "无",
          hasDirection: false,
          className: "",
          animateIcon: "animate-none",
          classNameDirection: []
        },
        {
          type: 1,
          name: "跑马灯",
          hasDirection: true,
          className: "",
          animateIcon: "animate-pmd",
          classNameDirection: [
            {
              disabled: false,
              title: "横向",
              className: ""
            },
            {
              disabled: false,
              title: "纵向",
              className: ""
            }
          ]
        }
      ]
    }
  },
  created() {},
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    hasDirection: {
      get() {
        // return this.getOptions && this.getOptions.animateSets.hasDirection;
        return this.getOptions && this.getOptions.animateSets ? this.getOptions.animateSets.hasDirection : null
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hasDirection", true, "animateSets")
      }
    },
    animateType: {
      get() {
        return this.getOptions && this.getOptions.animateSets ? this.getOptions.animateSets.animateType : null
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "animateType", true, "animateSets")
      }
    },
    animateDirection: {
      get() {
        // return this.getOptions && this.getOptions.animateSets.animateDirection;
        return this.getOptions && this.getOptions.animateSets && this.getOptions.animateSets.animateDirection != "无"
          ? this.getOptions.animateSets.animateDirection
          : "横向"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "animateDirection", true, "animateSets")
      }
    },
    animateDuration: {
      get() {
        return this.getOptions && this.getOptions.animateSets ? this.getOptions.animateSets.animateDuration : null
      },
      set(newVal) {
        newVal !== this.animateDuration && this.$changeOptionsEV(newVal, "animateDuration", true, "animateSets")
      }
    },
    animateDelay: {
      get() {
        return this.getOptions && this.getOptions.animateSets ? this.getOptions.animateSets.animateDelay : null
      },
      set(newVal) {
        newVal !== this.animateDelay && this.$changeOptionsEV(newVal, "animateDelay", true, "animateSets")
      }
    },
    animateTriggerNumType: {
      get() {
        // return this.getOptions && this.getOptions.animateSets.animateTriggerNumType;
        return this.getOptions && this.getOptions.animateSets ? this.getOptions.animateSets.animateTriggerNumType : null
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "animateTriggerNumType", true, "animateSets")
      }
    },
    animateClass: {
      get() {
        // return this.getOptions && this.getOptions.animateSets.animateClass;
        return this.getOptions && this.getOptions.animateSets ? this.getOptions.animateSets.animateClass : null
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "animateClass", true, "animateSets")
      }
    },
    getOptions: function () {
      return this.$getOptions()
    }
  },
  mounted() {
    this.getAnimateDirections()
  },
  methods: {
    // 第一次获取组件动画的设置方向列表
    getAnimateDirections: function () {
      for (let key in this.animateTypes) {
        if (this.animateTypes[key].type === this.animateType) {
          this.animateDirections.list = this.animateTypes[key].classNameDirection || []
          break
        }
      }
    },
    changeAnimateType: function (animate) {
      this.animateType = animate.type
      this.hasDirection = animate.hasDirection
      this.animateClass = animate.className
      this.animateDirections.list = animate.classNameDirection || []
      // this.animateDirection = this.animateDirections.list.length > 0 ? this.animateDirections.list[0].title : ""
      this.$forceUpdate()
    },
    getCheckedHandle(data, options, type) {
      switch (type) {
        case "方向":
          let seletedDirection
          this.animateDirection = data
          for (const key in this.animateTypes) {
            if (this.animateTypes[key].type === this.animateType) {
              seletedDirection = this.animateTypes[key].classNameDirection
              break
            }
          }
          for (const key1 in seletedDirection) {
            if (seletedDirection[key1].title === this.animateDirection) {
              this.animateClass = seletedDirection[key1].className
              break
            }
          }
          break
        case "触发次数":
          this.animateTriggerNumType = data
          console.log(this.animateTriggerNumType)
          break
      }
    },
    restoreSettings() {
      for (let key in this.initialSets) {
        if (this.initialSets[key] !== this[key]) {
          this[key] = this.initialSets[key]
        }
      }
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.setting-item {
  margin-bottom: 20px;
}

.setting-item .options {
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.8);
  font-weight: 500;
}

/*.setting-item /deep/ .el-radio__input.is-checked + .el-radio__label {*/
/*  color: rgba(0, 0, 0, 0.6);*/
/*}*/

.animate-types {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}

.animate-types > li {
  text-align: center;
  cursor: pointer;
  font-size: 12px;
}

.animate-icon-box {
  position: relative;
}

.animate-types > li:not(:nth-child(4n)) {
  margin-right: 36px;
}
.bigScreen-toolbar .animate-types > li:not(:nth-child(4n)) {
  margin-right: 21px;
}
.animate-types > li.active .animate-icon {
  /*outline: 2px solid var(--themeColor);*/
  box-shadow: 0 0 0 2px var(--themeColor);
}

.animate-types .animate-icon {
  display: inline-block;
  width: 60px;
  height: 60px;
  border-radius: 4px;
  overflow: hidden;
  box-sizing: border-box;
}
.animate-none {
  background: url("../../../assets/images/animate_icon/none.png") 100% 100%;
}
.animate-types > li.active .animate-none {
  background: url("../../../assets/images/animate_icon/none_selected.png") 100% 100%;
}
.animate-pmd {
  background: url("../../../assets/images/animate_icon/pmd.png") 100% 100%;
}
.animate-types > li.active .animate-pmd {
  background: url("../../../assets/images/animate_icon/pmd_selected.png") 100% 100%;
}
.animate-selected {
  position: absolute;
  display: inline-block;
  width: 24px;
  height: 24px;
  right: 0;
  top: 36px;
  z-index: 2;
  background: url("../../../assets/images/animate_icon.png") -5px -215px;
  background-size: 280px 244px;
}

.recover-default-set {
  text-align: right;
}

.recover-btn /deep/ .cxBtn {
  width: 102px;
  height: 32px;
  padding: 0 14px 0 10px;
  color: var(--themeColor);
  font-size: 14px;
  border: 1px solid var(--themeColor);
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
}

.recover-default-set .icon-portal-refresh {
  display: inline-block;
  transform: rotate(45deg);
  margin-right: 4px;
}
.height28,
::v-deep.height28.el-input .el-input__inner {
  height: 28px;
}
.el-radio {
  margin-right: 16px;
}
.el-radio:last-child {
  margin-right: 0;
}
.setting-item.el-button--default:focus {
  border: 1px solid var(--themeColor);
  color: var(--themeColor);
  background-color: var(--defaultButtonHover);
}
</style>
